module.exports = __webpack_public_path__ + "img/INTERIOR-CIAZ-4.b3a57011.jpg";